import React from 'react'
import './Profile.css'
import withPolyglot from '../../common/withPolyglot'

function getMedicalStaffProfession (gender, profession) {
  if (profession === '') {
    return ''
  } else {
    return gender === 'M' ? `${profession}Male` : `${profession}Female`
  }
}

const Profile = ({medicalStaff = {}, translate}) => {
  return <div className='uk-container uk-margin-small uk-padding-small'>
    <h3 className='uk-padding-small'>{translate('medicalStaffProfile')}</h3>
    <div data-uk-grid className='uk-grid no-side-margin profile-grid uk-padding-small'>
      <div className='uk-width-1-1 uk-width-2-3@s'><h4>{medicalStaff.name}</h4></div>
      <div className='uk-width-1-1 uk-width-1-3@s uk-text-right padding-right'><span>
        {medicalStaff.profession ? translate(getMedicalStaffProfession(medicalStaff.gender, medicalStaff.profession)) : ''}
      </span></div>
      <hr className='uk-width-1-1 uk-margin-small' />
      <div className='uk-width-1-1 uk-width-2-5@s'>
        <div className='info-description'>{translate('professionalCertificate')}</div> <span>{medicalStaff.professionalCertificate}</span>
      </div>
      <div className='uk-width-1-1 uk-width-3-5@s uk-text-right padding-right'>
        <div className='info-description'>{translate('location')}</div> <span>{medicalStaff.location}</span>
      </div>
      <hr className='uk-width-1-1 uk-margin-small' />
      <div className='uk-width-1-1 uk-width-1-2@s'>
        <div className='info-description'>{translate('landNumber')}</div> <span>{medicalStaff.landNumber}</span>
      </div>
      <div className='uk-width-1-1 uk-width-1-2@s uk-text-right padding-right'>
        <div className='info-description'>{translate('mobileNumber')}</div> <span>{medicalStaff.mobileNumber}</span>
      </div>
      <hr className='uk-width-1-1 uk-margin-small' />
      <div className='uk-width-1-1'>
        <div className='info-description'>{translate('email')}</div> <span>{medicalStaff.email}</span>
      </div>
      <hr className='uk-width-1-1' />
      <div className='uk-width-1-1'>
        <button className='uk-button uk-button-primary uk-align-center' disabled>Histórico da Produtividade</button>
      </div>
    </div>
  </div>
}

export default withPolyglot(Profile, 'profile')
